import {
  ApiResponse,
  FeedbackResponseData,
  FeedbackLimitData,
} from '../models/apiResponse';
import { FeedbackData } from '../models/feedBackModel';
import { apiRequests as requests } from './http-client';

const Feedback = {
  submitFeedback: (feedbackData: FeedbackData) =>
    requests
      .post<ApiResponse<FeedbackResponseData>>('/v1/feedback', feedbackData)
      .then((response) => response.data),

  limitFeedback: () =>
    requests
      .get<ApiResponse<FeedbackLimitData>>('/v1/feedback/limit')
      .then((response) => response.data),
};

export default Feedback;
